import React from 'react';
import styled from 'styled-components';
import teamImage from '../assets/bg3.jpg';

const PageContainer = styled.div`
  padding-top: 120px; // Space for fixed header
`;

const AboutSection = styled.section`
  max-width: 900px;
  margin: 40px auto;
  background: white;
  padding: 30px 40px;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  
  @media (max-width: 768px) {
    padding: 20px;
    margin: 20px;
  }
`;

const PageTitle = styled.h2`
  text-align: center;
  color: #145757;
  margin-bottom: 20px;
  font-size: 2.2rem;
`;

const Paragraph = styled.p`
  line-height: 1.7;
  margin-bottom: 20px;
`;

const Highlight = styled.span`
  color: #145757;
  font-weight: bold;
`;

const TeamPhoto = styled.img`
  width: 100%;
  border-radius: 10px;
  margin-top: 30px;
  box-shadow: 0 6px 12px rgba(0,0,0,0.1);
`;

const AboutPage = () => {
  return (
    <PageContainer>
      <AboutSection>
        <PageTitle>About Skyline Terrace Apartments</PageTitle>
        <Paragraph>
          Skyline Terrace Apartments is a <Highlight>premium residential development</Highlight> nestled in the scenic beauty of the Galiyat region. 
          We aim to deliver a modern, tranquil, and luxurious living experience for families, individuals, and investors seeking peace and elegance in one place.
        </Paragraph>
        
        <Paragraph>
          Founded in collaboration with the <Highlight>Ahmed Group</Highlight> and <Highlight>D. Watson</Highlight>, 
          Skyline Terrace brings over two decades of construction excellence to one of Pakistan's most beautiful landscapes. 
          Our commitment to quality, innovation, and client satisfaction sets us apart in the real estate industry.
        </Paragraph>
        
        <Paragraph>
          From <strong>panoramic views</strong> to <strong>modern interiors</strong> and <strong>eco-friendly design</strong>, 
          each apartment is crafted to offer both luxury and comfort. Our mission is to build more than just buildings — we build communities where people thrive.
        </Paragraph>
        
        <Paragraph>
          Whether you're looking for a permanent residence, a holiday home, or a lucrative investment opportunity, 
          Skyline Terrace Apartments is your ideal choice.
        </Paragraph>
        
        <TeamPhoto src={teamImage} alt="Our Team" />
      </AboutSection>
    </PageContainer>
  );
};

export default AboutPage; 